import { render, staticRenderFns } from "./resourceLibraryDialog.vue?vue&type=template&id=47b5836f&scoped=true"
import script from "./resourceLibraryDialog.vue?vue&type=script&lang=js"
export * from "./resourceLibraryDialog.vue?vue&type=script&lang=js"
import style0 from "./resourceLibraryDialog.vue?vue&type=style&index=0&id=47b5836f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b5836f",
  null
  
)

export default component.exports